import { render, staticRenderFns } from "./SubscriptionPlanAddDrawer.vue?vue&type=template&id=b6f8b100&scoped=true&"
import script from "./SubscriptionPlanAddDrawer.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlanAddDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f8b100",
  null
  
)

export default component.exports